import type { CaseInvestigationTrackerRow } from '../models/case-investigation-tracker-row.model';

/** Lowercase haystack for Action Alert search; aligns with label "Attention Req!" for `attention` rows. */
function actionAlertSearchHaystack(row: CaseInvestigationTrackerRow): string {
  if (row.actionAlert === 'attention') {
    return 'attention attention req!';
  }
  return String(row.actionAlert ?? 'none').toLowerCase();
}

export function filterCaseInvestigationTrackerRowsBySearch(
  rows: readonly CaseInvestigationTrackerRow[],
  search: string | undefined
): CaseInvestigationTrackerRow[] {
  const term = (search ?? '').trim().toLowerCase();
  if (!term) return [...rows];
  return rows.filter(
    (r) =>
      r.employee.toLowerCase().includes(term) ||
      r.employeeId.toLowerCase().includes(term) ||
      r.jobRole.toLowerCase().includes(term) ||
      String(r.caseStatus).toLowerCase().includes(term) ||
      String(r.employeeStatus).toLowerCase().includes(term) ||
      r.createdBy.toLowerCase().includes(term) ||
      r.editedBy.toLowerCase().includes(term) ||
      String(r.createdDateTime ?? '').toLowerCase().includes(term) ||
      actionAlertSearchHaystack(r).includes(term)
  );
}
